export default __webpack_public_path__ + "static/media/iconViveport.55256732.svg";